import { MediaDocument } from '../media-document/media-document.model';
import { MediaContactDocument } from '../media-contact-document/media-contact-document.model';

export class MediaSourceDocument {
    __originalDocument__: any;
    id: string;

    name: string;
    geoFocus: MediaSourceGeoFocusType;
    url: string;
    location: MediaSourceAddress;
    beats: string[];
    tags: string[];
    uniqueVisitors: number;
    initial: string;
    detail: MediaSourceDetail;

    documents: MediaDocument[];
    documentsCount: number;
    documentsVisibleCount: number;
    documentsLoading: boolean = false;

    contacts: MediaContactDocument[];
    contactsCount: number;
    contactsVisibleCount: number;
    contactsLoading: boolean = false;

    activeTray: string;
    selected: boolean = false;

    constructor(originalDoc?: any) {
        this.__originalDocument__ = originalDoc;
    }
}

export interface MediaSourceDetail {
    summary?: string;
    phones?: MediaSourcePhoneNumber[];
    emails?: MediaSourceEmail[];
    socialProfiles?: MediaSourceSocialProfile[];

    primaryPhone?: MediaSourcePhoneNumber;
    primaryEmail?: MediaSourceEmail;
}

export interface MediaSourceAddress {
    country?: string;
    stateOrProvince?: string;
    city?: string;
}

export interface MediaSourcePhoneNumber {
    type: MediaSourcePhoneNumberType;
    number: string;
    primary: boolean;
}

export interface MediaSourceEmail {
    type: MediaSourceEmailType;
    address: string;
    primary: boolean;
}

export interface MediaSourceSocialProfile {
    type: MediaSourceSocialProfileType,
    url: string
}

export enum MediaSourceGeoFocusType {
    International = 'International',
    Local = 'Local'
}

export enum MediaSourcePhoneNumberType {
    Mobile = 'mobile',
    Home = 'home',
    Work = 'work',
    Fax = 'fax',
    Other = 'other'
}

export enum MediaSourceEmailType {
    Personal = 'personal',
    Work = 'work',
    Other = 'other'
}

export enum MediaSourceSocialProfileType {
    Facebook = 'facebook',
    Twitter = 'twitter',
    Linkedin = 'linked_in',
    Xing = 'xing',
    GooglePlus = 'googleplus',
    YouTube = 'youtube',
    Other = 'other'
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-source-document/media-source-document.model.ts